$("body").on("change", ".submit-on-change", function() {
  var $this = $(this),
      $form = $this.closest('form');
  if($form.length > 0) { $form.submit(); }
})

$("body").on("input", ".submit-on-input", function() {
  var $this = $(this),
      $form = $this.closest('form');
  if($form.length > 0) {
    if(this.timeOut !== "undefined") clearTimeout(this.timeOut);

    this.timeOut = setTimeout(function() {
      $form.submit();
    }, 250)
  }
})

$("body").on("change", ".submit-on-stop", function() {
  var $this = $(this),
      $form = $this.closest('form');
  if($form.length > 0) {
    if(this.stopTimeout !== undefined) clearTimeout(this.stopTimeout);

    this.stopTimeout = setTimeout(function() {
      $form.submit();
    }, 400)
  }
})

$("body").on("focus", ".form-control:not([readonly])", function(){
  $(this).closest('.form-group').addClass('focus')
}).on("blur", ".form-control:not([readonly])", function(){
  $(this).closest('.form-group').removeClass('focus')
})
